import React from 'react';

export const RestartButton = props => (
	<div className="restart">
		<button className='btn' {...props} style={{padding: 'auto'}} >Restart Game</button>				
	</div>
);